import type { Config, ConfigBase } from './configType';

export const sharedFields: ConfigBase = {
  widgetsSubdomain: true,
  // TODO: vaults prod - confirm we use same or different app as on dev
  xNetworkClientId: 'SnFrVzhDbWJGVEVYNmhMMnY0dzY6MTpjaQ',
};

// https://stargateprotocol.gitbook.io/stargate/v/v2-developer-docs/technical-reference/v2-supported-networks-and-assets
// Supported chains https://github.com/kumabid/kuma-sdk-js/blob/beta/src/bridge/config.ts#L49

export const configProduction: Config = {
  ...sharedFields,
  env: 'production',
  envIsSandbox: false,
  // intercomId: 'kabhwtc0', // Same as V1
  turnstileCaptchaSiteKey: '0x4AAAAAAALJhPC4yF6RepWf',
  delegatedKeyExpirationDays: 30,

  chains: {
    arbitrum: {
      chainNetwork: 'Arbitrum',
      chainBlockExplorer: 'https://arbiscan.io',
      chainId: 42161,
      chainCurrency: 'ETH',
      chainRpc: 'https://arb1.arbitrum.io/rpc',
      // chainRpc: 'https://arb-mainnet.g.alchemy.com/v2/979MV7YKPPJPVr9B_bt4BANboThZv6f5',
      chainRpcSoftwareWallet: true,
      // depositPaused: true,
      usdcTokenAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831', // USDC.e '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    },
    avalanche: {
      chainNetwork: 'Avalanche',
      chainBlockExplorer: 'https://avascan.info/blockchain/c',
      chainId: 43114,
      chainCurrency: 'AVAX',
      chainRpc: 'https://api.avax.network/ext/bc/C/rpc', // https://docs.avax.network/build/dapp/chain-settings
      chainRpcSoftwareWallet: true,
      // depositNotAvailable: true,
      usdcTokenAddress: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    },
    baseEVM: {
      chainNetwork: 'Base',
      chainBlockExplorer: 'https://base.blockscout.com',
      chainId: 8453,
      chainCurrency: 'ETH',
      chainRpc:
        'https://base-mainnet.g.alchemy.com/v2/979MV7YKPPJPVr9B_bt4BANboThZv6f5',
      // chainRpcSoftwareWallet: true,
      chainRpcSoftwareWallet: 'https://mainnet.base.org', // Rate limited https://docs.base.org/docs/network-information
      averageBlockTimeSec: 2,
      usdcTokenAddress: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    },
    beraChain: {
      chainNetwork: 'Berachain',
      chainBlockExplorer: 'https://berascan.com',
      chainId: 80094,
      chainCurrency: 'BERA',
      chainRpc: 'https://rpc.berachain.com',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 2,
      usdcTokenAddress: '0x549943e04f40284185054145c6E4e9568C1D3241', // USDC.e
      usdcTokenDecimalsOverride: 6, // TODO: bera decimals?
      // bgtRewardVaultAddress: '0x5540e29749f6c8f5dcf49fcc17c67e97a8e7335b',
      // iBgtRewardOperatorAddress: '0xb71b3DaEA39012Fb0f2B14D2a9C86da9292fC126',
      // lbgtRewardOperatorAddress: '0xFeedb9750d6ac77D2E52e0C9EB8fB79F9de5Cafe',
    },
    bnbSmartChain: {
      chainNetwork: 'BNB Smart Chain',
      chainBlockExplorer: 'https://bscscan.com',
      chainId: 56,
      chainCurrency: 'BNB',
      chainRpc: 'https://bsc-dataseed.bnbchain.org',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 1,
      depositNotAvailable: true,
      usdcTokenAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      usdcTokenDecimalsOverride: 18,
    },
    ethereum: {
      chainNetwork: 'Ethereum',
      chainId: 1,
      chainRpc:
        'https://eth-mainnet.g.alchemy.com/v2/979MV7YKPPJPVr9B_bt4BANboThZv6f5',
      // chainRpc: 'https://mainnet.infura.io/v3/97dad3c59dce48579f4cfb8ed43ab6b3',
      chainCurrency: 'ETH',
      chainRpcSoftwareWallet: true,
      // alchemyRpc: 'https://eth-mainnet.alchemyapi.io/v2/hJqtc8xBbmqRuGja8Zp4Cfon2Sh7IFMj',
      chainBlockExplorer: 'https://etherscan.io',
      // gasStationDefipulseApiKey: '84bc7e5629c62592770f6f8484ac67e35efc16e28d6b2dc05d7f0c75b180', // https://data.defipulse.com
      averageBlockTimeSec: 13,
      usdcTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    },
    /** https://docs.katana.network/katana/technical-reference/network-information/ */
    katanaChain: {
      chainId: 747474,
      chainNetwork: 'Katana',
      chainCurrency: 'ETH',
      chainRpc: 'https://rpc.katana.network/',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://katanascan.com',
      usdcTokenAddress: '0x203A662b0BD271A6ed5a60EdFbd04bFce608FD36',
      // usdcTokenSymbolOverride: 'vbUSDC',
      blocksConfirmation: 1,
      preferredChain: true,

      restApiUrl: 'https://api-perps.katana.network/v1',
      webSocketApiUrl: 'wss://websocket-perps.katana.network/v1',

      averageBlockTimeSec: 1,
      exchangeContract: '0x62230CeA619F734cc215bB8074bbF07bE4Eb633e',
      stargateAdapterV3Address: '0x47b1FAb829bBEF9Cb5A76D72fe0E7bB5ccD4A244',
      stargateJumpChain: 'ethereum',
      stargateJumpChainForwarderAddress:
        '0x984d0BA343fB4D3D34Ac1375CFFdf03115193EFD',

      // TODO: katana prod config vaults deposit
      localDepositAdapterV1KatanaContractAddress: '',
      // TODO: katana prod config vaults deposit
      loopbackBridgeAdapterV1KatanaContractAddress: '',

      // // TODO: vaults prod configuration
      fixedIncomeVaultProviderAddress: '',
      profitShareVaultProviderAddress: '',
      // Profit Share vaults are not launched on Production - creation stays
      // disabled even once the provider is deployed
      profitShareVaultCreationDisabled: true,
      // Removed - the `stateAggregator` address comes from the vaults API response
      // fixedIncomeVaultProviderStateAggregatorAddress: '',
      fixedIncomeVaultMinInterestMultiplier: 0n,
      fixedIncomeVaultMaxInterestMultiplier: 0n,
      fixedIncomeVaultMaxNetDeposits: 100000000000000000n,
      fixedIncomeVaultMinNetDeposits: 10000000000n,
      fixedIncomeVaultMinWithdrawalLimitPercentForVault: 0n,
      fixedIncomeVaultMaxWithdrawalLimitPercentForVault: 100000000n,
      fixedIncomeVaultMinWithdrawalLimitPercentForDepositors: 10000000n,
      fixedIncomeVaultMaxWithdrawalLimitPercentForDepositors: 100000000n,
      fixedIncomeVaultMinExitThresholdMultiplier: 50000000n,
      fixedIncomeVaultMaxExitThresholdMultiplier: 200000000n,
      fixedIncomeVaultMinWithdrawalThresholdMultiplier: 50000000n,
      fixedIncomeVaultMaxWithdrawalThresholdMultiplier: 999999999n,
      fixedIncomeVaultMinDepositWithdrawalExitAgeInS: 3600n,
      fixedIncomeVaultMaxDepositWithdrawalExitAgeInS: 2419200n,
      // TODO: vaults prod Profit Share provider constants (not deployed yet,
      // copied from dev)
      profitShareVaultMaxCarryFeeMultiplier: 99999999n,
      profitShareVaultMaxManagementFeeMultiplier: 1000000000n,
      profitShareVaultManagementFeePeriodInS: 31536000n,
      profitShareVaultMinNetDeposits: 10000000000n,
      profitShareVaultMaxNetDeposits: 100000000000000000n,
      profitShareVaultMinWithdrawalLimitPercentForVault: 0n,
      profitShareVaultMaxWithdrawalLimitPercentForVault: 100000000n,
      profitShareVaultMinWithdrawalLimitPercentForDepositors: 10000000n,
      profitShareVaultMaxWithdrawalLimitPercentForDepositors: 100000000n,
      profitShareVaultMinDepositWithdrawalExitAgeInS: 3600n,
      profitShareVaultMaxDepositWithdrawalExitAgeInS: 2419200n,
    },
    mantle: {
      chainNetwork: 'Mantle',
      chainBlockExplorer: 'https://mantlescan.xyz',
      chainId: 5000,
      chainCurrency: 'MNT',
      chainRpc: 'https://rpc.mantle.xyz',
      chainRpcSoftwareWallet: true,
      depositNotAvailable: true,
      usdcTokenAddress: '0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9',
    },
    optimism: {
      chainNetwork: 'Optimism',
      chainBlockExplorer: 'https://optimistic.etherscan.io',
      chainId: 10,
      chainCurrency: 'ETH',
      chainRpc:
        'https://opt-mainnet.g.alchemy.com/v2/979MV7YKPPJPVr9B_bt4BANboThZv6f5',
      chainRpcSoftwareWallet: 'https://mainnet.optimism.io', // Rate-limited
      usdcTokenAddress: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85', // USDC.e '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
    },
    polygonPoS: {
      chainNetwork: 'Polygon PoS',
      chainBlockExplorer: 'https://polygonscan.com',
      chainId: 137,
      chainCurrency: 'POL',
      chainRpc: 'https://polygon-rpc.com/',
      chainRpcSoftwareWallet: 'https://polygon-rpc.com/',
      // alchemyRpc: 'https://polygon-mainnet.g.alchemy.com/v2/S5p3l0HFoaTHSADR2fIzSrcSAUEW_T9y',
      averageBlockTimeSec: 2.3,
      depositNotAvailable: true,
      usdcTokenAddress: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', // 0x2791bca1f2de4661ed88a30c99a7a9449aa84174
    },
    seiChain: {
      chainNetwork: 'Sei',
      chainBlockExplorer: 'https://www.seiscan.app',
      chainId: 1329,
      chainCurrency: 'SEI',
      chainRpc: 'https://evm-rpc.sei-apis.com',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 1,
      depositNotAvailable: true,
      usdcTokenAddress: '0x3894085Ef7Ff0f0aeDf52E2A2704928d1Ec074F1',
    },
    // NEW_CHAIN: {
    //   chainNetwork: '',
    //   chainBlockExplorer: '',
    //   chainId: 0,
    //   chainCurrency: '',
    //   chainRpc: '',
    //   chainRpcSoftwareWallet: true,
    //   averageBlockTimeSec: 0,
    //   usdcTokenAddress: '',
    // },
  },
} satisfies Config;
